/**
 * @desc 深度拷贝数组/对象
 * @param obj - 需要克隆的数组/对象
 * @returns 克隆后的数组/对象
 */

/* eslint-disable */

declare let window: Window & { JSON: any };

/* eslint-enable */

export function deepClone(obj: any) {
  let str;
  let newobj: any = obj.constructor === Array ? [] : {};
  if (typeof obj !== 'object') {
    return;
  } else if (window.JSON) {
    str = JSON.stringify(obj);
    newobj = JSON.parse(str);
  } else {
    for (const i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i];
    }
  }
  return newobj;
}
